export const PARTICIPANT_TYPES = Object.freeze({
    TEST: 1,
    MAIN: 2,
});
